import { Component, Inject } from '@angular/core';
import { CrmActivityRecordChangeBaseComponent } from './record-change-base.component';
import {
  CrmFieldService,
  CrmObjectService,
  CrmObjectDisplayService,
  StandardIds,
} from '../../../../../../shared-services';
import { ActivityCardComponent } from '../activity-card/activity-card.component';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { MatCardModule } from '@angular/material/card';
import { TranslationModule } from '../../../../../../i18n/translation-module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { CrmDependencies, CrmInjectionToken } from '../../../../../../tokens-and-interfaces';
import { TranslateForCrmObjectService } from '../../../../../../i18n/translate-for-crm-object/translate-for-crm-object.service';
import { ActivityAssociationService } from '../../../../activities';
import { CRMChangeLogApiService } from '@vendasta/crm';
import { map } from 'rxjs/operators';

@Component({
  selector: 'crm-activity-record-change-opportunity-status-change',
  templateUrl: './record-change-opportunity-status-change.component.html',
  styleUrls: ['./record-change.component.scss', './record-change-opportunity-status-change.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    TranslationModule,
    MatCardModule,
    GalaxyPipesModule,
    GalaxyAvatarModule,
    ActivityCardComponent,
    RouterLink,
  ],
})
export class CrmActivityRecordChangeOpportunityStatusChangeComponent extends CrmActivityRecordChangeBaseComponent {
  protected readonly statusData$ = this.changeLogData$.pipe(
    map((changeLog) => {
      const newStatus = changeLog ? this.getStringFieldData(changeLog, StandardIds.OpportunityStatus) : '';
      const updateReason = changeLog ? this.getStringFieldData(changeLog, StandardIds.OpportunityClosedLostReason) : '';
      const updateDesc = changeLog
        ? this.getStringFieldData(changeLog, StandardIds.OpportunityClosedLostReasonDescription)
        : '';

      if (!newStatus) {
        return null;
      }

      // Determine the CSS class based on status
      let statusClass = '';
      const lowerStatus = newStatus.toLowerCase();
      if (lowerStatus.includes('won')) {
        statusClass = 'status-won';
      } else if (lowerStatus.includes('lost')) {
        statusClass = 'status-lost';
      }

      return {
        status: newStatus,
        statusClass,
        reason: updateReason,
        description: updateDesc,
      };
    }),
  );

  constructor(
    fieldService: CrmFieldService,
    translateForCrmObjectService: TranslateForCrmObjectService,
    changeLogService: CRMChangeLogApiService,
    objectService: CrmObjectService,
    objectDisplayService: CrmObjectDisplayService,
    translate: TranslateService,
    activityAssociationService: ActivityAssociationService,
    @Inject(CrmInjectionToken) config: CrmDependencies,
  ) {
    super(
      fieldService,
      translateForCrmObjectService,
      changeLogService,
      objectService,
      objectDisplayService,
      translate,
      activityAssociationService,
      config,
    );
  }
}
